import * as Yup from "yup"

const required = label => Yup.string().trim().required(`${label} est obligatoire.`)

export const fiscalValidationSchema = Yup.object({
  legalName: required("La raison sociale").max(255, "Maximum 255 caractères."),
  legalForm: required("La forme juridique").max(100, "Maximum 100 caractères."),
  ice: required("L’ICE").matches(/^\d{15}$/, "L’ICE doit contenir exactement 15 chiffres."),
  fiscalIdentifier: required("L’identifiant fiscal")
    .max(30, "Maximum 30 caractères.")
    .matches(/^[a-zA-Z0-9-]+$/, "Utilisez uniquement des caractères alphanumériques et des tirets."),
  commercialRegisterNumber: required("Le numéro du registre de commerce").max(50, "Maximum 50 caractères."),
  professionalTaxNumber: required("Le numéro de taxe professionnelle").max(50, "Maximum 50 caractères."),
  cnssNumber: Yup.string().trim().max(50, "Maximum 50 caractères."),
})

